import store from "../store";
import { actionTypes } from "./saga";

/**
 * @module ReportsSaga
 */

/**
 *
 * @param {object} data
 */
export function setReportsData(data) {
  store.dispatch({
    type: actionTypes.SET_REPORTS_DATA,
    payload: {
      data: data
    }
  });
}

export function uploadReport(data) {
  store.dispatch({
    type: actionTypes.UPLOAD_REPORT,
    payload: data
  });
}
